import { useEffect } from 'react'

import type { UseQueryResult } from '@tanstack/react-query'
import axios from 'axios'

import { ApiError } from '@/types/api'

const IS_DEV = import.meta.env.DEV || window.location.hostname.startsWith('dev-')

const devLog = (message: string) => {
  if (!IS_DEV) return
  window.dispatchEvent(new CustomEvent('dev:log', { detail: message }))
}

export const useDevQueryLog = (label: string, query: UseQueryResult<unknown, Error>) => {
  useEffect(() => {
    if (!IS_DEV || query.isLoading) return

    if (query.error) {
      const err = query.error
      if (err instanceof ApiError) {
        devLog(`${label} 실패 — [${err.status}] code=${err.code} desc=${err.description}`)
      } else if (axios.isAxiosError(err)) {
        devLog(`${label} 실패 — [${err.response?.status ?? 'none'}] ${err.config?.url ?? '?'} ${err.message}`)
      } else {
        devLog(`${label} 실패 — ${err.message}`)
      }
      return
    }

    devLog(`${label}: ${JSON.stringify(query.data)}`)
  }, [label, query.data, query.error, query.isLoading])
}

export { devLog }
